import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {},
  input: {},
  labelRoot: {
    '&$focused': {
      color: palette.text.secondary,
    },
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  inputUnderline: {
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$focused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  focused: {},
  hovered: {},
  disabled: {
    color: palette.disabledInput.color,
  },
  helpIcon: {
    fontSize: '0.60rem',
    marginRight: 4,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
  },
  checkbox: {
    '&:hover': {
      backgroundColor: 'rgba(0, 173, 141, 0.15) !important',
    },
    color: '#01B3C5 !important',
    padding: '3px 3px 3px 3px',
    marginLeft: 5,
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  label: {
    fontSize: 16,
    alignItems: 'flex-start',
  },
}), { name: 'FormInput' });

export default useStyles;
